export var ArchiveStatus;
(function (ArchiveStatus) {
    ArchiveStatus["NONE"] = "none";
    ArchiveStatus["ENABLED"] = "enabled";
    ArchiveStatus["DISABLED"] = "disabled";
})(ArchiveStatus || (ArchiveStatus = {}));
export var ArchiveAndRestoreTabs;
(function (ArchiveAndRestoreTabs) {
    ArchiveAndRestoreTabs["Archive"] = "Archive";
    ArchiveAndRestoreTabs["Restore"] = "Restore";
    ArchiveAndRestoreTabs["RestoredAccounts"] = "Restored Accounts";
    ArchiveAndRestoreTabs["ManualRestore"] = "Manually Restored Accounts";
})(ArchiveAndRestoreTabs || (ArchiveAndRestoreTabs = {}));
export var ArchiveAndRestoreStorageType;
(function (ArchiveAndRestoreStorageType) {
    ArchiveAndRestoreStorageType["AWS"] = "S3";
    ArchiveAndRestoreStorageType["AZURE"] = "BLOB";
})(ArchiveAndRestoreStorageType || (ArchiveAndRestoreStorageType = {}));
export var S3AuthenticationTypes;
(function (S3AuthenticationTypes) {
    S3AuthenticationTypes["IAM"] = "IAM";
    S3AuthenticationTypes["SECRET"] = "KEYS";
})(S3AuthenticationTypes || (S3AuthenticationTypes = {}));
export var ArchiveAndRestoreSubject;
(function (ArchiveAndRestoreSubject) {
    ArchiveAndRestoreSubject["SwitchStorage"] = "switch-storage";
    ArchiveAndRestoreSubject["PageTabs"] = "archive-and-restore-tabs";
    ArchiveAndRestoreSubject["SettingsStorageTabs"] = "archive-settings-tabs-storage";
    ArchiveAndRestoreSubject["ArchivingWarningSwitchToAzure"] = "inline-warn-aws-archiving";
    ArchiveAndRestoreSubject["ArchiveSettingsTabContent"] = "archive-settings-tab-content";
})(ArchiveAndRestoreSubject || (ArchiveAndRestoreSubject = {}));
export var ArchiveAzureInputSubjects;
(function (ArchiveAzureInputSubjects) {
    ArchiveAzureInputSubjects["TenantId"] = "azure-tenant-id";
    ArchiveAzureInputSubjects["ClientId"] = "azure-client-id";
    ArchiveAzureInputSubjects["ClientSecret"] = "azure-client-secret";
    ArchiveAzureInputSubjects["AccountName"] = "azure-account-name";
    ArchiveAzureInputSubjects["ContainerName"] = "azure-container-name";
    ArchiveAzureInputSubjects["StoragePathPrefix"] = "azure-storage-path-prefix";
})(ArchiveAzureInputSubjects || (ArchiveAzureInputSubjects = {}));
export var AzureFormFieldsError;
(function (AzureFormFieldsError) {
    AzureFormFieldsError["AccountNameRegex"] = "Storage account can include only lowercase letters and numbers";
    AzureFormFieldsError["AccountNameMinLength"] = "Length must be at least 3 characters";
    AzureFormFieldsError["AccountNameMaxLength"] = "Length can be up to 24 characters";
    AzureFormFieldsError["ContainerNameRegex"] = "Container can include only lowercase letters, numbers, and hyphens (`\u2013`)";
    AzureFormFieldsError["ContainerHyphensPattern"] = "Must start and end with a letter or a number and cannot include consecutive hyphens";
    AzureFormFieldsError["ContainerNameMinLength"] = "Length must be at least 3 characters";
    AzureFormFieldsError["ContainerNameMaxLength"] = "Length can be up to 63 characters";
    AzureFormFieldsError["PathSlashesValidations"] = "Virtual sub-folder cannot start or end with a slash (`/`)";
    AzureFormFieldsError["PathMaxSlashes"] = "Sub-folder can include up to 254 forward slashes (\u2018/\u2019)";
    AzureFormFieldsError["PathMaxLength"] = "Length can be up to 974 URL characters";
})(AzureFormFieldsError || (AzureFormFieldsError = {}));
export var ArchiveNotificationSubject;
(function (ArchiveNotificationSubject) {
    ArchiveNotificationSubject["TestSettings"] = "test-archive-settings";
    ArchiveNotificationSubject["CreateArchiveSettings"] = "create-archive-settings";
    ArchiveNotificationSubject["UpdateArchiveSettings"] = "update-archive-settings";
    ArchiveNotificationSubject["StopArchiving"] = "stop-archiving";
    ArchiveNotificationSubject["RestartArchiving"] = "restart-archiving";
    ArchiveNotificationSubject["DeleteArchiveSettings"] = "delete-archive-settings";
    ArchiveNotificationSubject["AssumeRoleDetails"] = "get-assume-role-details";
    ArchiveNotificationSubject["CopyRolePolicy"] = "copy-role-policy";
})(ArchiveNotificationSubject || (ArchiveNotificationSubject = {}));
export var ArchiveButtonSubjects;
(function (ArchiveButtonSubjects) {
    ArchiveButtonSubjects["ChangeToAccessKey"] = "change-to-access-key";
    ArchiveButtonSubjects["ChangeToIAMRole"] = "change-to-iam";
    ArchiveButtonSubjects["StartArchiving"] = "start-archiving-button";
    ArchiveButtonSubjects["PauseArchiving"] = "pause-archiving-button";
    ArchiveButtonSubjects["RestartArchiving"] = "restart-archiving-button";
    ArchiveButtonSubjects["TestConnection"] = "test-connection-button";
    ArchiveButtonSubjects["MigrateToIAM"] = "migrate-to-iam";
    ArchiveButtonSubjects["RevertToAccessKey"] = "revert-to-access-key";
})(ArchiveButtonSubjects || (ArchiveButtonSubjects = {}));
export var ArchiveSettingsStatusSubject;
(function (ArchiveSettingsStatusSubject) {
    ArchiveSettingsStatusSubject["notConfigured"] = "not-configured";
    ArchiveSettingsStatusSubject["archiving"] = "archiving";
    ArchiveSettingsStatusSubject["paused"] = "paused";
})(ArchiveSettingsStatusSubject || (ArchiveSettingsStatusSubject = {}));
export var ArchiveInputSubjects;
(function (ArchiveInputSubjects) {
    ArchiveInputSubjects["BucketName"] = "bucket-name";
    ArchiveInputSubjects["ARN"] = "role-arn";
    ArchiveInputSubjects["AccessKey"] = "access-key";
    ArchiveInputSubjects["SecretKey"] = "secret-key";
})(ArchiveInputSubjects || (ArchiveInputSubjects = {}));
export var RestoreNotificationSubject;
(function (RestoreNotificationSubject) {
    RestoreNotificationSubject["CreateRestore"] = "create-restore";
    RestoreNotificationSubject["DeleteRestore"] = "delete-restore";
    RestoreNotificationSubject["EstimationCostRecieved"] = "estimation-cost-recieved";
})(RestoreNotificationSubject || (RestoreNotificationSubject = {}));
export var RestoreSubjects;
(function (RestoreSubjects) {
    RestoreSubjects["ProceedRestoreButton"] = "proceed-restore-button";
    RestoreSubjects["SubmitRestoreButton"] = "submit-restore";
    RestoreSubjects["AccountNameInput"] = "account-name-input";
    RestoreSubjects["PowerSearchInput"] = "power-search-input";
    RestoreSubjects["EstimateScanCostButton"] = "estimate-scan-cost-button";
    RestoreSubjects["RestoreDateRangePicker"] = "restore-date-range";
    RestoreSubjects["RestoreContainer"] = "restore-container";
    RestoreSubjects["RestoreConfigCard"] = "restore-config-card";
    RestoreSubjects["FiltersCard"] = "filters-card";
    RestoreSubjects["PowerSearchCard"] = "power-search-card";
    RestoreSubjects["RestoreTimezoneSelect"] = "restore-timezone-select";
})(RestoreSubjects || (RestoreSubjects = {}));
export var RestoredAccountsSubjects;
(function (RestoredAccountsSubjects) {
    RestoredAccountsSubjects["RestoredAccountsTable"] = "restored-accounts-table";
    RestoredAccountsSubjects["DeleteRestore"] = "delete-restore";
    RestoredAccountsSubjects["FilterBar"] = "restored-accounts-filter-bar";
    RestoredAccountsSubjects["NoMatchingRestoredAccounts"] = "no-matching-restored-accounts";
    RestoredAccountsSubjects["RowActionsTrigger"] = "restored-accounts-row-actions";
    RestoredAccountsSubjects["ViewLogs"] = "view-restore-logs";
})(RestoredAccountsSubjects || (RestoredAccountsSubjects = {}));
export var RestoreDataSourceType;
(function (RestoreDataSourceType) {
    RestoreDataSourceType["ColdStorage"] = "COLD_STORAGE";
    RestoreDataSourceType["Archive"] = "ARCHIVE";
})(RestoreDataSourceType || (RestoreDataSourceType = {}));
export var RestorePhase;
(function (RestorePhase) {
    RestorePhase["Preparing"] = "PREPARING";
    RestorePhase["Reading"] = "READING";
    RestorePhase["Indexing"] = "INDEXING";
    RestorePhase["Ready"] = "READY";
})(RestorePhase || (RestorePhase = {}));
//# sourceMappingURL=archive-and-restore.js.map